import axios from 'axios'

const API_BASE = 'https://club-services.intrare.app'
const API_KEY = 'NK3ZlH8Jzhk4Vgwdti3cQ_VyG99v323seGTwozqtCgw'

const instance = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
})

export default {
  /**
   * Obtiene familias inscritas en el torneo de niños
   * @param {Object} options - Opciones de búsqueda y paginación
   * @param {string} options.search - Busca en nombre, email, teléfono del padre
   * @param {number} options.page - Número de página (default: 1)
   * @param {number} options.page_size - Registros por página (default: 10, máx: 100)
   * @param {string} options.tournament_code - Código específico del torneo
   * @param {boolean} options.attended - Filtrar por asistencia
   * @returns {Promise} Lista de familias con sus miembros
   */
  async getTournamentFamilies (options = {}) {
    try {
      const params = {
        api_key: API_KEY,
        ...options
      }

      const response = await instance.get('/temp-tournament-members/kids-families/', { params })
      return response.data
    } catch (error) {
      console.error('Error fetching tournament families:', error)
      throw error
    }
  },

  /**
   * Busca familias por nombre, email o teléfono
   * @param {string} search - Término de búsqueda
   * @param {number} page - Número de página
   * @param {number} page_size - Registros por página
   * @returns {Promise} Resultados de búsqueda
   */
  async searchFamilies (search, page = 1, page_size = 10) {
    try {
      const params = {
        api_key: API_KEY,
        search,
        page,
        page_size
      }

      const response = await instance.get('/temp-tournament-members/kids-families/', { params })
      return response.data
    } catch (error) {
      console.error('Error searching families:', error)
      throw error
    }
  },

  /**
   * Obtiene solo los asistentes del torneo
   * @param {number} page - Número de página
   * @param {number} page_size - Registros por página
   * @returns {Promise} Lista de familias asistentes
   */
  async getAttendees (page = 1, page_size = 10) {
    try {
      const params = {
        api_key: API_KEY,
        attended: true,
        page,
        page_size
      }

      const response = await instance.get('/temp-tournament-members/kids-families/', { params })
      return response.data
    } catch (error) {
      console.error('Error fetching attendees:', error)
      throw error
    }
  }
}
